import React from 'react';
import PropTypes from 'prop-types';

export const withGuard = (Component) => {
  return function WithGuard({ show = true, ...rest }) {
    if (show === false) {
      return null;
    }
    WithGuard.propTypes = {
      show: PropTypes.bool,
    };
    return <Component {...rest} />;
  };
};

withGuard.propTypes = {
  Component: PropTypes.func.isRequired,
};
